import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';
import type { OfferStatus } from '@core/offers-types';

type TrackPublishParams = {
  jobStatus: OfferStatus;
  hasPublish: boolean;
  hasClose: boolean;
};

@Injectable({ providedIn: 'root' })
export class JobSchedulerAnalytics extends AnalyticsBase {
  public readonly namespace = `JobScheduler`;
  public readonly requireViewContext = false;

  public trackSchedulePublish(params: TrackPublishParams): void {
    this.track('SchedulePublish', params);
  }

  public trackFilterScheduled(): void {
    this.track('FilterScheduled');
  }
}
